const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

export function formatSum(num: number | string): string {
    const innerValue = Number(num);

    if (num === null || Number.isNaN(innerValue) || !Number.isFinite(innerValue)) {
        console.log('Некорректный параметр');
        return '';
    }

    return formatter.format(innerValue).replace(/,/g, ' ');
}
